/**
 * FacilitiesSearch
 * Search facilities by number
 */
export default class FacilitiesSearch {

    constructor(selector) {
        this.$form = $(selector)
        this.xhrPath = this.$form.attr('action')
        this.spinnerUrl = this.$form.data('tncp-spinner-url')
        this.$input = this.$form.find('[data-tncp-facilitiessearch-input]')
        this.$popupMessage = this.$form.find('[data-tncp-facilitiessearch-message]')
        this.$popupResult = this.$form.find('[data-tncp-facilitiessearch-result]')
        this.activePopupClass = 'c-facilities-search__child--active'
        this.$searchWord = ''
        this.search()
    }

    search() {
        let vm = this

        vm.$input.focus(function() {
            if (vm.$input.val().length > 0) {
                vm.hidePopupMessage()
                vm.showPopupResults()

            } else {
                vm.showPopupMessage()
            }
        })
        vm.$input.blur(function() {
            setTimeout(function() {
                vm.hidePopupMessage()
                vm.hidePopupResults()
            }, 150);
        })

        // on enter - submit to list page
        if (this.$input.length > 0) {
            $(window).on('keypress', this.$input, function (e) {
                if (e.which === 13) {
                    e.preventDefault()
                    e.stopPropagation()
                }
            });
        }

        $(window).on('keyup', this.$input, _.debounce(function () {
            this.$searchWord = vm.$input.val()
            if (this.$searchWord != undefined && this.$searchWord.length > 3) {
                vm.searchApi(this.$searchWord)
            } else {
                vm.hidePopupResults()
            }
        }, 400));
    }


    searchApi(searchWord) {
        let vm = this
        this.$popupResult.html('<img style="margin: 0px auto;" src="' + this.spinnerUrl + '" alt="Loading" />')
        vm.showPopupResults()
        vm.hidePopupMessage()
        axios.post(
            vm.xhrPath,
            'tx_tuevnordcustomerportal_api%5BsearchWord%5D=' + searchWord, { headers : {'Content-Type': 'application/x-www-form-urlencoded'}}
        ).then((response) => {
            this.$popupResult.html(response.data.content)
        })
    }

    showPopupMessage() {
        this.$popupMessage.addClass(this.activePopupClass)
    }

    hidePopupMessage() {
        this.$popupMessage.removeClass(this.activePopupClass)
    }

    showPopupResults() {
        this.$popupResult.addClass(this.activePopupClass)
    }

    hidePopupResults() {
        this.$popupResult.removeClass(this.activePopupClass)
    }
}
